import { useAIAuth } from '../lib/AIAuthContext';
import { useChatStore } from './useChatStore';

// Verbindet den Store mit Token aus dem AIAuthContext
export function useSendQuestion() {
  const { getAccessToken, standort } = useAIAuth();
  const sendQuestion = useChatStore((state) => state.sendQuestion);

  return (question: string) =>
    sendQuestion(question, { getAccessToken, standortId: standort.id });
}
